import styled from 'styled-components';
import { DeprecatedGrid as Grid } from '@simplywallst/ui-core';

export const Wrapper = styled(Grid)`
  border-left: ${({ theme }) => theme.x0_5}px solid
    ${({ theme }) => theme.color.brand03};

  ul {
    list-style-type: '■';

    li::marker {
      color: ${({ theme }) => theme.color.brand03};
      ${({ theme }) => theme.typography.xSmall};
    }
  }
`;
